import { EMBED_MESSAGE_TYPE, MESSAGE_SOURCES } from '../constants/messages';

/**
 * Wraps an event the editor sends in the single message envelope the chat
 * listens for (see constants/messages.js). `id` and `payload` are left out
 * when not given.
 */
const toHostMessage = ({ event, id, payload }) => ({
  type: EMBED_MESSAGE_TYPE,
  meta: {
    source: MESSAGE_SOURCES.HOST,
    event,
    ...(id !== undefined && { id }),
  },
  ...(payload !== undefined && { payload }),
});

export default toHostMessage;
